import React, { useEffect, useState } from 'react'
import '../styles/ArtworkStyle.css'
import ArtworkHeader from '../artwork/ArtworkHeader';
import Fullscreen from './Fullscreen';

function Artwork() {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null); // Store the selected image

  const images = [
    // { id: 1, src: './images/moon.jpg', alt: 'The Moon' },
    // { id: 2, src: './images/select.jpg', alt: 'The Sun' },
    // { id: 3, src: './images/icon.jpg', alt: 'Stars' },
    // { id: 4, src: './images/icon.jpg', alt: 'Stars' },
    // { id: 5, src: './images/icon.jpg', alt: 'Stars' },
    // { id: 6, src: './images/icon.jpg', alt: 'Stars' }
  ];

  const fullscreenHandler = (img) => {
    setCurrentImage(img);
    setIsFullscreen(true);
  };

  const closeFullscreen = () => {
    setIsFullscreen(false);
    setCurrentImage(null);
    }

      // Escape key handler
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isFullscreen) {
        closeFullscreen();
      }
    };

    // Add event listener when fullscreen is open
    if (isFullscreen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    // Cleanup on unmount or when fullscreen closes
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isFullscreen]); // Dependency ensures listener updates when `isFullscreen` changes

  return (
    <div>
      <ArtworkHeader />
      <h2 style={{color: 'white', textAlign: 'center'}}>press 'escape' to end fullscreen or click outside</h2>
      <div id='ArtworkDiv'>
        {images.map((img) => (
          <img
            key={img.id}
            src={img.src}
            alt={img.alt}
            onClick={() => fullscreenHandler(img)}
          />
        ))}
        <p id='ComingSoon'>Coming Soon...</p>
      </div>

      {isFullscreen && currentImage && (
        <Fullscreen
          source={currentImage.src}
          onClose={closeFullscreen} // Also triggered by Escape
        />
      )}
    </div>
  );
}

export default Artwork
